<ng-container *ngIf="conditionalContent$ | async as conditionalContent">
  <app-conditional-content
    [conditionalContent]="conditionalContent | fillUrls | localizeAbsUrls"
  ></app-conditional-content>
</ng-container>
